// @ts-nocheck


import React from 'react';
import { TabItem, Tabs } from './../../../../../components/ui';





export default ({ vehiclePlanId }) => {
  return (
    <Tabs withRouter>
      <TabItem
        label="Текущий ремонт"
        url={`/budget/vehicle/${vehiclePlanId}/current-repair`} />

      <TabItem
        label="Капитальный ремонт"
        url={`/budget/vehicle/${vehiclePlanId}/overhaul-repair`} />

      <TabItem
        label="Бюджет по ремонтам"
        url={`/budget/vehicle/${vehiclePlanId}/budget-repair`} />

    </Tabs>);

};
